import React from "react";
import Text from "../components/shared/components/Text";

export function objectTypesConfigToArray(objectType) {
  return Object.keys(objectType).map((type) => ({
    value: objectType[type].value,
    display: <Text tId={objectType[type].name} />,
  }));
}
